<template>
	<div class="onlineMallDetail">
		<div class="onlineMallDetail-box">
			<el-page-header @back="goBack" content="商品详情" class="header">
			</el-page-header>	
			<el-row :gutter="20" class="content">
				<el-col :span="9">
					<el-image :src="data.img ? data.img:url" class="image" fit="cover" :preview-src-list="[data.img]"></el-image>
				</el-col>
				<el-col :span="15">
					<div class="name">
						{{data.name}}
					</div>
					<div class="company">
						<el-tag>{{data.company}}</el-tag>
					</div>
					<div class="price">
						<div>价格：</div>
						<div>
							{{data.price}}
						</div>
					</div>
					<el-descriptions class="" :column="2" contentClassName="">
<!-- 						<el-descriptions-item label="是否专属产品">是</el-descriptions-item>
						<el-descriptions-item label="合作商户">智慧职安环保科技有限公司</el-descriptions-item>
						<el-descriptions-item label="联系人">谢大脚</el-descriptions-item>
						<el-descriptions-item label="联系电话">15875436959</el-descriptions-item> -->
						<el-descriptions-item label="发布时间">{{data.date}}</el-descriptions-item>
						<el-descriptions-item label="销量">{{data.sales}}</el-descriptions-item>
					</el-descriptions>
					<div class="buyBtn">
						<el-button type="primary" @click="getBuy">立即购买</el-button>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24" class="summary">
					<div class="header">
						产品简介
					</div>
					<div class="content" v-html="data.content"></div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import './index.less';
	export default {
		data() {
			return {
				data: {},
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
			}
		},
		methods: {
			goBack() {
				this.$router.back(-1)
			},
			getBuy(){
				this.$router.push({
					path: `/login`,
				})
			}
		},
		mounted() {
			this.data = this.$route.query
			console.log(this.$route.query)
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/onlineMall/onlineMallDetail/index.vue